var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.scanSimpleInput,_vm._b({staticClass:"pg-scan-add-medical",attrs:{"disabled":_vm.disabled},on:{"on-change":_setup.scanSimpleChange}},'scanSimpleInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }